import { AnimatePresence } from 'framer-motion'
import { useFooterSlotClaim } from '../../../atoms'

/**
 * Whatever has claimed the footer's bottom slot, over the chat input. The claim
 * carries its own surface, so the footer never grows a branch per feature — and
 * a surface isn't tied to the view it was opened from: the meeting notepad is
 * claimed from Home, the Meeting View and the Action View alike, and stays put
 * as the user moves between them rather than exiting and re-entering.
 */
export function SidepanelFooterOverlay() {
  const claim = useFooterSlotClaim()
  const Surface = claim?.component

  // One stable key, not the open view's id: the slot's surface persists across
  // navigation rather than exiting and re-entering, which would refocus the
  // notepad's textarea and re-read its notes off disk on every move.
  return <AnimatePresence>{Surface && <Surface key="footer-slot" />}</AnimatePresence>
}
